import { render, staticRenderFns } from "./ValidateDialog.vue?vue&type=template&id=7b84ff4b&scoped=true"
import script from "./ValidateDialog.vue?vue&type=script&lang=js"
export * from "./ValidateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b84ff4b",
  null
  
)

export default component.exports